// src/i18n/i18n.js
// ─────────────────────────────────────────────────────────────
//  react-i18next setup for Dar Oulmes
//  Default language: Arabic (ar)  |  Supports: ar, fr, en
//  RTL is applied automatically on <html> when Arabic is active
// ─────────────────────────────────────────────────────────────

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import ar from "./locales/ar/translation.json";
import fr from "./locales/fr/translation.json";
import en from "./locales/en/translation.json";

// RTL languages
const RTL_LANGS = ["ar"];

// Apply dir + lang attributes to <html> whenever language changes
const applyDocumentDirection = (lng) => {
  const isRTL = RTL_LANGS.includes(lng);
  document.documentElement.setAttribute("dir",  isRTL ? "rtl" : "ltr");
  document.documentElement.setAttribute("lang", lng);
};

i18n
  .use(LanguageDetector)   // detects from localStorage, navigator, etc.
  .use(initReactI18next)
  .init({
    resources: {
      ar: { translation: ar },
      fr: { translation: fr },
      en: { translation: en },
    },

    // Default / fallback language
    lng:          "ar",
    fallbackLng:  "ar",

    // Language detection order
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "dar_oulmes_lang",
    },

    interpolation: {
      escapeValue: false, // React already escapes
    },

    // Namespace (single namespace keeps things simple for a small app)
    defaultNS: "translation",
    ns:        ["translation"],
  });

// Apply direction on startup
applyDocumentDirection(i18n.language);

// Apply direction on every language change
i18n.on("languageChanged", applyDocumentDirection);

export default i18n;